<div class="block" *ngIf="block" [class.gathering]="block.gathering" [ngClass]="block.category" [ngStyle]="{ 'animation': showActive && animationActive ? getAnimationStyle() + '1000ms infinite' : ''}">
  <i *ngIf="copied" class="fa-solid fa-check share-icon" [class.gathering]="block.gathering" [ngClass]="block.category"></i>
  <span *ngIf="copied" class="share-icon copied-text" [class.gathering]="block.gathering" [ngClass]="block.category">Gekopieerd</span>
  <i *ngIf="!copied" class="fa-regular fa-link share-icon" [class.gathering]="block.gathering" [ngClass]="block.category" (click)="copyToClipboard()"></i>
  <p class="date" *ngIf="block.gatheringDate">{{ gatheringDate | date: 'd MMMM' }}</p>
  <p class="date" *ngIf="!block.gatheringDate && block.dateDisplayOverride" [ngClass]="block.category">{{ block.dateDisplayOverride }}</p>
  <p class="date" *ngIf="!block.gatheringDate && !block.dateDisplayOverride" [ngClass]="block.category">Van {{ beginDate | date: 'd MMMM' }} tot {{ endDate | date: 'd MMMM' }}</p>
  <div class="text-wrapper" [ngClass]="block.category">
    <app-document-renderer [document]="block.coverText?.document"></app-document-renderer>
    <div class="flex-wrapper">
      <a 
        *ngIf="block.details" 
        (click)="toggleDetailView()"
        gtagEvent 
        trackOn="click" 
        action="more_information_clicked"
        category="clicks" 
        [params]="{ event_label: 'Meer informatie (' + (block.coverText?.document?.[0]?.children?.[0]?.text ?? 'Onbekend') + ')' }">Meer informatie <i class="fa-light fa-circle-arrow-down"></i></a>
      <a 
        class="download-button" 
        *ngIf="downloadFile" 
        [href]="downloadFile.url"
        gtagEvent 
        trackOn="click" 
        action="download_clicked"
        category="clicks" 
        [params]="{ event_label: 'Download (' + (block.coverText?.document?.[0]?.children?.[0]?.text ?? 'Onbekend') + ')' }"
      >
        <i class="fa-light fa-paperclip" *ngIf="downloadFile.type === 'DOCUMENT'"></i>
        <i class="fa-light fa-image" *ngIf="downloadFile.type === 'IMAGE'"></i>
        <i class="fa-light fa-clapperboard-play" *ngIf="downloadFile.type === 'VIDEO'"></i>
        <ng-container *ngIf="downloadFile.type === 'DOCUMENT' || downloadFile.type === 'IMAGE'">Download</ng-container>
        <ng-container *ngIf="downloadFile.type === 'VIDEO'">Bekijken</ng-container>
      </a>
    </div>
  </div>
</div>

